<template>
  <div>
    <vue-headful :title="pageTitle"/>
    <v-layout>
      <h1>{{ title }}</h1>
      <v-spacer></v-spacer>
      <div style="min-width: 250px; margin-right: 10px;">
        <v-combobox v-model="selectedCategories" multiple :items="categories" label="Категория"
                    @change="initRoute" item-text="value"/>
      </div>
      <div style="min-width: 350px;">
        <v-combobox v-model="selectedAttestationStatuses" multiple :items="attestationStatuses" label="Статус"
                    @change="initRoute"/>
      </div>
      <v-btn class="mr-0 primary" :to="{name: 'AdminGroupAdd', query: {orgId: $route.query.orgId}}">Добавить</v-btn>
    </v-layout>
    <DataTable :items="list" :headers="headers">
      <tr slot-scope="props">
        <td class="text-xs-center">{{ props.index+1 }}</td>
        <td>{{ categoryName(props.item.category) }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.organization.name }}</td>
        <td>{{ props.item.attestationInfo.date}}</td>
        <td>{{ props.item.attestationInfo.status}}</td>
        <td class="justify-center layout px-0">
          <v-btn flat icon :to="{name: 'AdminGroupView', params: {id: props.item.id.toString()}}">
            <v-icon small>remove_red_eye</v-icon>
          </v-btn>
          <v-btn v-if="editable(props.item.attestationInfo.status)" flat icon
                 :to="{name: 'AdminGroupEdit', params: {id: props.item.id.toString()}}">
            <v-icon small>edit</v-icon>
          </v-btn>
          <v-btn flat icon @click="deleteConfirm(props.item)">
            <v-icon small>delete</v-icon>
          </v-btn>
        </td>
      </tr>
    </DataTable>
    <pagination :pagination="pagination" @currentPageChanged="initRoute"/>
    <DeleteConfirmDialog :dialog="deleteDialog" @confirm="confirm">
      <p>Название: {{ deleteDialog.item.name }}</p>
    </DeleteConfirmDialog>
    <ErrorDialog :dialog="errorDialog"/>
  </div>
</template>

<script>
import SettingsService from '@/services/SettingsService'
import DataTable from '@/components/fragments/DataTable'
import GroupService from '@/services/GroupService'
import DeleteConfirmDialog from '@/components/fragments/DeleteConfirmDialog'
import ErrorDialog from '@/components/fragments/ErrorDialog'
import CategoryService from '@/services/CategoryService'
import Pagination from '@/components/fragments/Pagination'

export default {
  components: {ErrorDialog, DeleteConfirmDialog, DataTable, Pagination},
  data: () => ({
    list: [],
    headers: [
      {text: '№', align: 'center', sortable: false, width: 50},
      {text: 'Категория', align: 'center', sortable: false, width: 130},
      {text: 'Название', align: 'left', sortable: false},
      {text: 'Организация', align: 'left', sortable: false},
      {text: 'Дата', align: 'center', sortable: false, width: 100},
      {text: 'Статус', align: 'center', sortable: false, width: 130},
      {text: 'Действия', align: 'center', sortable: false, width: 156}
    ],
    deleteDialog: {
      status: false,
      item: GroupService.getDefaultItem()
    },
    errorDialog: {
      status: false,
      errors: [],
      title: 'Ошибка при удалении'
    },
    pagination: {
      currentPage: 1,
      totalPages: 1
    },
    attestationStatuses: [
      {value: 1, text: 'Тренировка'},
      {value: 2, text: 'Не началась'},
      {value: 3, text: 'В процессе'},
      {value: 4, text: 'Завершена'}
    ],
    selectedAttestationStatuses: [],
    selectedCategories: [],
    categories: CategoryService.getList(),
    replaceRoute: false,
    forceReload: false,
    groupService: undefined
  }),
  computed: {
    title () {
      return this.$route ? this.$route.meta.title : ''
    },
    pageTitle () {
      return SettingsService.pageTitle(this.title)
    }
  },
  methods: {
    getSelectedTypes () {
      let types = []
      this.selectedAttestationStatuses.forEach(it => types.push(it.value))
      return types
    },
    getSelectedCategories () {
      let categories = []
      this.selectedCategories.forEach(it => categories.push(it.value))
      return categories
    },
    editable (status) {
      return this.groupService.isEditable(status)
    },
    initRoute () {
      let query = {}
      query.page = this.pagination.currentPage
      query.type = this.getSelectedTypes()
      query.category = this.getSelectedCategories()
      if (this.replaceRoute) {
        this.$router.replace({query: query})
      } else {
        this.$router.push({query: query})
      }
    },
    loadList () {
      if (this.forceReload || !this.$store.getters.isLoading) {
        this.groupService.getList((data) => {
          this.pagination.totalPages = data.totalPages
          if (this.pagination.currentPage > this.pagination.totalPages) {
            this.forceReload = true
            this.replaceRoute = true
            this.pagination.currentPage = this.pagination.totalPages
          } else {
            this.forceReload = false
            this.replaceRoute = false
            this.list = data.list
          }
        }, {
          page: this.pagination.currentPage,
          type: this.getSelectedTypes(),
          category: this.getSelectedCategories(),
          orgId: this.$route.query.orgId
        })
      }
    },
    deleteConfirm (item) {
      this.deleteDialog.item = item
      this.deleteDialog.status = true
    },
    confirm () {
      this.groupService.deleteItem(this.deleteDialog.item.id, (data) => {
        if (data.status) {
          this.forceReload = true
          this.loadList()
        } else {
          this.errorDialog.errors = data.errors
          this.errorDialog.status = true
        }
      })
    },
    categoryName (category) {
      return CategoryService.getList()[category - 1].text
    }
  },
  created () {
    this.pagination.currentPage = this.$route.query.page ? Number.parseInt(this.$route.query.page) : 1
    this.selectedAttestationStatuses = this.$route.query.type ? this.attestationStatuses.filter(it => this.$route.query.type.includes(it.value.toString())) : []
    this.selectedCategories = this.$route.query.category ? this.categories.filter(it => this.$route.query.category.includes(it.value.toString())) : []
    this.groupService = new GroupService(this.$store)
    this.loadList()
  },
  watch: {
    'deleteDialog.status' (val) {
      if (!val) {
        this.deleteDialog.item = GroupService.getDefaultItem()
      }
    },
    '$route.query': {
      handler () {
        this.loadList()
      },
      deep: true
    }
  },
  beforeRouteUpdate (to, from, next) {
    next()
    this.loadList()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admin/group/Index.vue